import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { PrivacyPolicy } from '@/screens/Legal/PrivacyPolicy';

export default function PrivacyPolicyPage() {
  return (
    <>
      <Head>
        <meta name="keywords" content="loadsmart privacy policy" />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        title="Privacy Policy"
        description="Privacy Policy at Loadsmart | Loadsmart"
        canonical="https://loadsmart.com/privacy-policy/"
        openGraph={{
          url: 'https://loadsmart.com/privacy-policy/',
        }}
      />
      <PrivacyPolicy />
    </>
  );
}
